import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { Footer } from './components/Footer';
import { useGptInit } from './hooks/useGptInit';
export function App() {
  useGptInit('Homepage');
  return <div className="min-h-screen bg-white w-full overflow-x-hidden font-['Poppins']" data-id="element-0">
      {/* ═══ HEADER ═══ */}
      <Header data-id="element-1" />

      {/* ═══ TOP AD BANNER (no ad yet) ═══ */}
      <div className="w-full h-[80px] md:h-[120px] lg:h-[150px]" style={{
      backgroundColor: '#6B6B6B'
    }} data-id="element-2" />

      {/* ═══ HERO SECTION ═══ */}
      <HeroSection data-id="element-3" />

      {/* ═══ FOOTER ═══ */}
      <Footer data-id="element-4" />
    </div>;
}